module.exports = __webpack_public_path__ + "static/media/ship-bg-mobile-isabelle.fb217726.jpg";